var map = {
	"./-1_0.svg": "ef9d",
	"./-1_1.svg": "8d8e",
	"./-1_a.svg": "fb1d",
	"./-2_0.svg": "6502",
	"./-2_1.svg": "6b16",
	"./-2_2.svg": "e55b",
	"./-2_3.svg": "1c9d",
	"./0_0.svg": "5033",
	"./0_1.svg": "625f",
	"./1_0.svg": "7fe2",
	"./1_1.svg": "8275",
	"./1_a.svg": "1b05",
	"./1_b.svg": "2c4e",
	"./2_0.svg": "ff1f",
	"./2_1.svg": "0fba",
	"./3_0.svg": "95b0",
	"./3_1.svg": "e2ee",
	"./4_0.svg": "3aa1",
	"./5_0.svg": "a2e5",
	"./5_1.svg": "9a9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37cf";